var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CContainer',{staticClass:"content-center min-vh-100"},[_c('CRow',{staticClass:"justify-content-center"},[_c('CCol',[_c('CCard',{staticClass:"p-4"},[_c('CCardBody',[_vm._v(" Email wird geändert ")])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }